import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {ImportReportStatus, StudentImportPostOptions} from "../../models/import-status.model";

export class ImportStatusService {
    /* @ngInject */
    constructor(
        private $http: angular.IHttpService,
        private API_URL: ApiUrl,
        private $q: angular.IQService
    ) {}

    private handleErrorResponse = (errorResponse) => {
        return errorResponse && errorResponse.status === 404 ? {} : this.$q.reject(errorResponse);
    }

    getAll(districtId: string): angular.IPromise<ImportReportStatus> {
        return this.$http.get(`${this.API_URL.importStatus.replace(/:districtId/, districtId)}`)
            .then((res: { data: ImportReportStatus }) => {
                return res.data;
            }, this.handleErrorResponse);
    }

    post(options: StudentImportPostOptions) {
        return this.$http.post(`${this.API_URL.importPost}`, options)
            .then((response: {status: number}) => response.status);
    }

    // TODO: Convert this method to return Promise<boolean> instead
    getPilotStatus(districtId: string): angular.IPromise<number> {
        return this.$http.get(`${this.API_URL.pilotStatus.replace(/:districtId/, districtId)}`, { cache: true })
            .then((response: {status: number}) => { return response.status; }, this.handleErrorResponse); 
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/import-status/import-status.service.ts